import { useLayoutEffect, useState } from "react";
import {
  FLOATING_CHAT_MIN_HEIGHT_PX,
  FLOATING_CHAT_REGION_VERTICAL_INSET_PX,
} from "./floatingChatShell";

export function fallbackMaxPanelHeightPx() {
  if (typeof window === "undefined") return 560;
  return Math.max(
    FLOATING_CHAT_MIN_HEIGHT_PX,
    Math.floor(window.innerHeight - 80),
  );
}

export function maxPanelHeightFromRegionEl(el: HTMLElement | null) {
  if (!el) return fallbackMaxPanelHeightPx();
  return Math.max(
    FLOATING_CHAT_MIN_HEIGHT_PX,
    Math.floor(el.clientHeight - FLOATING_CHAT_REGION_VERTICAL_INSET_PX),
  );
}

/**
 * Max height (px) a floating chat window may grow to inside its content region:
 * the region's `clientHeight` less a vertical inset, ResizeObserver-tracked.
 * Height (unlike width) stays meaningful even while a full-width detail pane
 * squeezes the region, so this caps the left-window mode too.
 */
export function useRegionMaxPanelHeight(el: HTMLElement | null): number {
  const [maxHeightPx, setMaxHeightPx] = useState(fallbackMaxPanelHeightPx);
  useLayoutEffect(() => {
    const update = () => {
      setMaxHeightPx(maxPanelHeightFromRegionEl(el));
    };
    update();
    if (!el) return;
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => ro.disconnect();
  }, [el]);
  return maxHeightPx;
}
